import '../scss/main.scss';
import '../utils/tag-filter';

import { loadSlider } from '../components/slider-component';
import { productCardVisible, sectionsLoadDefer } from '../components/sections-defer';
import { initWindows, onloadMemory, windowsToggle } from '../components/windows';
import { mountPredictiveSearch } from '../components/predictive-search';
import { closeQuickWithKey } from '../components/modal-product-card';

loadSlider();

window.addEventListener('DOMContentLoaded', () => {
  sectionsLoadDefer();
  onloadMemory();
  windowsToggle({
    scope: '#nav-list-movil-js',
    memory: true,
  })
  initWindows({
    control: '#burger-nav-js',
    target: '#nav-list-movil-js',
  });
  mountPredictiveSearch();
  closeQuickWithKey();
  productCardVisible();
});

window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    window.location.reload();
  }
});
